import axios from 'axios'
import { API_ROOT, API_TIMEOUT, config } from '../../config/config'
import { doGet } from './utils'
import { isEmpty } from 'lodash-es'

// const API_ROOT = 'http://localhost:9010/api'

let isRefreshing = false
let refreshSubscribers = []

// ฟังก์ชันสำหรับช่วยเก็บ Request ที่รออยู่เข้าคิว
const subscribeTokenRefresh = (cb) => {
  refreshSubscribers.push(cb)
}

// ฟังก์ชันสำหรับเคลียร์คิวและปล่อยทุกตัววิ่งต่อเมื่อได้ Token ใหม่แล้ว
const onRefreshed = (token) => {
  refreshSubscribers.map((cb) => cb(token))
  refreshSubscribers = []
}

export const authen = (code, state) => {
  //const API_ROOT = 'http://localhost:9010/api'
  const url = `${API_ROOT}/identity/auth`
  const body = { code: code || '', state: state || '' }
  return axios
    .post(url, body, API_TIMEOUT)
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      throw error
    })
}

export const refreshToken = (accessToken, refreshToken) => {
  //const API_ROOT = 'http://localhost:9010/api'
  const url = `${API_ROOT}/identity/refresh-token`
  const body = { access_token: accessToken || '', refresh_token: refreshToken || '' }
  return axios
    .post(url, body, API_TIMEOUT)
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      throw error
    })
}

export const getCheckUser = (email) => {
  const url = `${API_ROOT}/check-user/${email}`
  return doGet(url)
}

export const logout = () => {
  return config.defaultLogoutUrl
}

export const clearSession = (url = config.defaultLoginUrl) => {
  var tokenType = localStorage.getItem('token_type')
  console.log('tokenType : ', tokenType)

  if (tokenType == 'OTP') {
    url = '/'
  }

  // console.log('url : ', url)

  clearLocalStorage()
  clearSessionStorage()

  if (url) {
    window.location.href = url
    window.opener = null
  }
}

export const reAuthen = async (params_code, params_state) => {
  // console.log('reAuthen')
  try {
    const response = await authen(params_code, params_state)
    if (response.success && response?.model?.tokenInfo?.access_token) {
      clearLocalStorage()
      setSession(response.model)
      setLocalStorage(response.model?.userInfo, params_code, params_state)

      if (response?.model?.pdpaInfo) {
        if (response.model.pdpaInfo.isAccepted) {
          localStorage.setItem('termsUrl', response.model.pdpaInfo.termsUrl)
        } else {
          window.location.href = response.model.pdpaInfo.redirectUrl
        }
      }

      return true
    } else {
      return false
    }
  } catch (e) {
    return false
  }
}

export const thangrathAuthen = (appId, mToken) => {
  // const API_ROOT = 'http://localhost:9010/api'
  const url = `${API_ROOT}/identity/thangrath/authen`

  const body = { appId: appId || '', mToken: mToken || '' }
  return axios
    .post(url, body, API_TIMEOUT)
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      throw error
    })
}

export const clearLocalStorage = () => {
  localStorage.clear()
}

export const clearSessionStorage = () => {
  const keepKeys = ['redirect-link']

  Object.keys(sessionStorage).forEach((key) => {
    if (!keepKeys.includes(key)) {
      sessionStorage.removeItem(key)
    }
  })
}

export const setLocalStorage = (userInfo, params_code, params_state) => {
  let code = userInfo?.activeRole
  let uid = userInfo?.uid
  let departmentCode = userInfo?.departmentCode
  let departmentName = userInfo?.departmentName

  localStorage.setItem('thp_user_code', code)
  localStorage.setItem('thp_user_uid', uid)
  localStorage.setItem('thp_user_email', userInfo?.email)
  localStorage.setItem('department_code', departmentCode)
  localStorage.setItem('department_name', departmentName)

  localStorage.setItem('params_code', params_code)
  localStorage.setItem('params_state', params_state)
}

export const setSession = (authResult) => {
  let expiresAt = JSON.stringify(
    authResult.tokenInfo.expires_minute * 60 * 1000 + new Date().getTime()
  )
  localStorage.setItem('access_token', authResult.tokenInfo.access_token)
  localStorage.setItem('expires_minute', expiresAt)

  localStorage.setItem('refresh_token', authResult.tokenInfo.refresh_token)
  localStorage.setItem('token_type', authResult.tokenInfo.token_type)
}

export const isAuthenticated = async () => {
  const refresh_token = localStorage.getItem('refresh_token')
  const accessToken = localStorage.getItem('access_token')
  const params_code = localStorage.getItem('params_code')
  const params_state = localStorage.getItem('params_state')

  const expiresAtRaw = localStorage.getItem('expires_minute')
  const expiresAt = expiresAtRaw ? JSON.parse(expiresAtRaw) : 0

  // ตรวจสอบว่า Token เดิมยังใช้งานได้อยู่ไหม
  let refreshTokenSuccess =
    new Date().getTime() < expiresAt && !isEmpty(accessToken) && !isEmpty(refresh_token)

  // ─── กรณีที่ 1: Token เดิมยังไม่หมดอายุ ───
  if (refreshTokenSuccess) {
    return true
  }

  // ─── กรณีที่ 2: ตัวแรกที่เข้ามาเจอแจ็กพอต (เป็นคนคุมคิว) ───
  if (!isRefreshing) {
    isRefreshing = true // ล็อกคิวทันที ตัวอื่นที่ตามมาต้องนั่งรอ

    try {
      console.log('--- [ตัวแรก] เริ่มขอ Refresh Token ---')
      const response = await refreshToken(accessToken, refresh_token)

      if (response?.access_token) {
        const expiresTime = JSON.stringify(
          (response.expires_minute || 0) * 60 * 1000 + new Date().getTime()
        )

        localStorage.setItem('access_token', response.access_token)
        localStorage.setItem('expires_minute', expiresTime)
        localStorage.setItem('refresh_token', response.refresh_token)
        localStorage.setItem('token_type', response.token_type)

        refreshTokenSuccess = true
      }
    } catch (e) {
      console.log('Refresh Token Fail: ', e)
      refreshTokenSuccess = false
    }

    // จุดสำคัญ: ถ้ารีเฟรชพัง แต่มีโค้ดสลับหน้า (Params) ให้ทำ reAuthen ให้เสร็จก่อนปล่อยคิว
    if (!refreshTokenSuccess && params_code && params_state) {
      try {
        console.log('--- [ตัวแรก] Refresh พัง แต่มี Params -> กำลังลุยทำ reAuthen ต่อ... ---')

        // รอให้ reAuthen ทำงานจนเสร็จสิ้น (คืนค่ากลับมาเป็น true หรือ false)
        const reAuthResult = await reAuthen(params_code, params_state)

        refreshTokenSuccess = reAuthResult // เอาผลลัพธ์จาก reAuthen มาเป็นสถานะสุดท้าย
      } catch (reAuthError) {
        console.log('reAuthen Error: ', reAuthError)
        refreshTokenSuccess = false
      }
    }

    // ด่านสุดท้าย: ทำทุกกระบวนการซ่อม Token เสร็จหมดแล้ว (ไม่ว่าจะผ่านช่องทางไหน)
    isRefreshing = false // ปลดล็อกสวิตช์หลัก
    onRefreshed(refreshTokenSuccess) // คืนคิว! ตะโกนบอกเพื่อนๆ ที่รออยู่ด้วยสถานะล่าสุด
    return refreshTokenSuccess // คืนค่าให้ตัวเองวิ่งต่อ
  }

  // ─── กรณีที่ 3: ตัวที่ 2, 3, 4... มาทีหลัง โดนกักตัวไว้ในคิว ───
  console.log('--- [ตัวแถม] เข้าคิวรอสัญญาณ... ---')
  return new Promise((resolve) => {
    subscribeTokenRefresh((finalSuccess) => {
      // ตัวแถมไม่ต้องคิดอะไรเลย รอรับผลลัพธ์ความสำเร็จสุดท้าย (finalSuccess) ที่ตัวแรกเคลียร์มาให้
      resolve(finalSuccess)
    })
  })
}

export const getAccessToken = () => {
  const accessToken = localStorage.getItem('access_token')
  if (!accessToken) {
    throw new Error('No access token found')
  }
  return accessToken
}
